import { useFieldArray, useFormContext, useWatch } from "react-hook-form";

export function StudiesDataTab() {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({ name: "languages" });
  // const {
  //   fields: studiesFields,
  //   append: appendStudied,
  //   remove: removeStudies,
  // } = useFieldArray({ name: "tertiaryStudies" });

  const maxLevelApprovedSelected = useWatch({
    name: "tertiaryStudies.0.maxLevelApproved",
  });
  const institutionSelected = useWatch({
    name: "tertiaryStudies.0.institution",
  });

  

  const addLanguage = () => {
    append({ name: "", level: "", institution: "" });
  };

  const removeLanguage = (index) => {
    remove(index);
  };

  const institutions = [
    {
      id: "liceo-colegio",
      name: "Liceo/ colegio",
      levels: [ "ciclobasico", "bachilleraro" ], 
    },
    {
      id: "utu",
      name: "UTU",
      levels: [ "ciclobasico", "bachilleraro" ], 
    },
    {
      id: "bachilleraro-agraria",
      name: "Agraria",
      levels: [ "ciclobasico", "bachilleraro" ], 
    },
    {
      id: "polo-tecnologico-utu",
      name: "Polo Tecnológico/UTU",
      levels: [ "tecnico" ],
    },
    {
      id: "talleres-don-bosco",
      name: "Talleres Don Bosco",
      levels: [ "tecnico" ],
    },
    {
      id: "iade",
      name: "IADE",
      levels: [ "tecnico" ],
    },
    {
      id: "crandon",
      name: "CRANDON",
      levels: [ "tecnico" ],
    },
    {
      id: "udelar",
      name: "Udelar",
      levels: [ "universitario" ],
    },
    {
      id: "utec",
      name: "UTEC",
      levels: [ "universitario" ],
    },
    {
      id: "universidad-catolica",
      name: "Universidad Católica",
      levels: [ "universitario" ],
    },
    {
      id: "ort",
      name: "ORT",
      levels: [ "universitario" ],
    },
    {
      id: "universidad-de-montevideo",
      name: "Universidad de Montevideo",
      levels: [ "universitario" ],
    },
    {
      id: "ude",
      name: "UDE",
      levels: [ "universitario" ],
    },
    {
      id: "claeh",
      name: "CLAEH",
      levels: [ "universitario" ],
    },
    {
      id: "otros",
      name: "Otros (especificar)",
      levels: [ "primaria", "ciclobasico", "bachilleraro", "tecnico", "universitario", "postgrado-master" ],
    }
  ]

  // const addStudy = () => {
  //   appendStudied({ level: "", lastYear: "", institution: "" });
  // };

  // const removeStudy = (index) => {
  //   removeStudies(index);
  // };

  const languageOptions = [
    {
      id: "frances",
      name: "Francés",
    },
    {
      id: "ingles",
      name: "Inglés",
    },
    {
      id: "italiano",
      name: "Italiano",
    },
    {
      id: "portugues",
      name: "Portugués",
    },
  ];

  const languages = useWatch({
    name: "languages",
  });


  return (
    <div className="c-profile-info__switchable js-switchable" data-content="2">
      <h3 className="u-hidden-for-seo">Formación</h3>
      {/* <!-- ESTUDIOS --> */}
      <h4 className="c-form__title">Estudios</h4>
      <div className="c-profile-info__section c-form__section">
        <ul>
          <li key={`studies.0`}>
            <div className="c-form__row c-form__row--2col">
              <label className="c-form__group c-form__col">
                <span className="c-form__label">Nivel máximo de estudio alcanzado</span>
                <span className="c-form__select">
                  <select
                    className="c-form__input"
                    name="maxLevelApproved"
                    id="maxLevelApproved"
                    {...register(`tertiaryStudies.0.maxLevelApproved`)}
                  >
                    <option value="">Seleccione un nivel</option>
                    <option value="primaria">Primaria</option>
                    <option value="ciclobasico">Ciclo básico (1ero a 3 ero secundaria)</option>
                    <option value="bachilleraro">Bachillerato (4to a 5to secundaria)</option>
                    <option value="tecnico">Técnico Terciario</option>
                    <option value="universitario">Universitario</option>
                    <option value="postgrado-master">Post-Grado/ Master</option>
                  </select>
                </span>
              </label>

              <label className="c-form__group c-form__col">
                <span className="c-form__label">Estado</span>
                <span className="c-form__select">
                  <select
                    className="c-form__input"
                    name="location-search"
                    id="location-search"
                    {...register(`tertiaryStudies.0.lastYearApproved`)}
                    defaultValue="quinto"
                  >
                    <option value="" disabled>
                      Seleccione el estado
                    </option>
                    <option value="completo">Completo</option>
                    <option value="incompleto">Incompleto</option>
                    <option value="cursando">Cursando</option>
                  </select>
                </span>
              </label>
            </div>

            <div className="c-form__row">
                <label className="c-form__group">
                  <span className="c-form__label">Indique dónde realizó los estudios </span>

                  <span className="c-form__select">
                  <select
                    className="c-form__input"
                    name="institution"
                    id="institution"
                    {...register(`tertiaryStudies.0.institution`)}
                  >
                    <option value="">
                      Seleccione la institución
                    </option>
                    {institutions &&
                      institutions.map((institution) => (
                        (institution?.levels.includes(maxLevelApprovedSelected) || institution.id === "otros") &&  
                        <option key={institution.id} value={institution.id}>
                          {institution.name}
                        </option>
                      ))}
                  </select> 
                </span>
                </label>
            </div>
              {(institutionSelected === 'otros') && <div className="c-form__row">
                <label className="c-form__group">
                    <span className="c-form__label">Indique el nombre</span>
                    <input
                    type="text"
                    name={`languages..extra`}
                    className="c-form__input"
                    placeholder="Ingresa el nombre de la institución..."
                    {...register(`tertiaryStudies.0.extra`, { required: true })}
                  />
                  {errors?.tertiaryStudies &&
                    errors.tertiaryStudies[0]?.extra &&
                    errors.tertiaryStudies[0]?.extra?.type === "required" && (
                      <span className="c-form__error">Este campo es obligatorio</span>
                    )}
                </label>
              </div>}
            {/*<div className="c-form__right-aligner">
              <button
                type="button"
                onClick={() => removeStudy(index)}
                className="c-form__btn c-form__btn-delete u-tap-size"
              >
                <span className="c-form__btn-icon icon-delete"></span>Eliminar estudio
              </button>
            </div>*/}
          </li>
        </ul>
        {/* <!-- SEPARATOR -->
        <div className="c-profile-info__separator"></div> */}

        {/* <!-- AÑADIR OTRO ESTUDIO --> 
        <button type="button" onClick={addStudy} className="c-form__btn-add--xl">
          <span className="c-form__btn-add-icon c-form__btn-add-icon--xl icon-more"></span>Añadir otro estudio
        </button>*/}
      </div>

      {/* <!-- SEPARATOR xl --> */}
      <div className="c-profile-info__separator c-profile-info__separator--xl"></div>

      {/* <!-- IDIOMAS --> */}
      <h4 className="c-form__title">Idiomas</h4>
      <div className="c-profile-info__section c-form__section">
        <ul>
          {fields &&
            fields.map((language, index) => {
              return (
                <li key={`languages.${index}`}>
                  {/* <!-- IDIOMA 1 --> */}
                  <div className="c-form__row c-form__row--2col">
                    <label className="c-form__group c-form__col">
                      <span className="c-form__label">Idioma</span>
                      <span className="c-form__select">
                        <select
                          className="c-form__input"
                          onChangeCapture={() => {
                            setValue(`languages.${index}.other`, "");
                          }}
                          name={`languages.${index}.name`}
                          {...register(`languages.${index}.name`)}
                        >
                          <option value="" disabled>
                            Seleccione un idioma
                          </option>
                          {languageOptions.map((language) => {
                            return <option value={language.id}>{language.name}</option>;
                          })}
                          <option value="otro">Otro...</option>
                        </select>
                      </span>
                    </label>
                    {(!languageOptions.some((language) => language.id === getValues(`languages.${index}.name`)) ||
                      (languages[index] && languages[index]?.name === "otro")) && (
                      <label className="c-form__group c-form__col">
                        <label className="c-form__group">
                          <span className="c-form__label">Indique cual</span>
                          <input
                            type="text"
                            name={`languages.${index}.other`}
                            className="c-form__input"
                            placeholder="Ingresa el idioma..."
                            {...register(`languages.${index}.other`, { required: true })}
                          />
                          {errors?.languages &&
                            errors.languages[index]?.other &&
                            errors.languages[index]?.other?.type === "required" && (
                              <span className="c-form__error">Este campo es obligatorio</span>
                            )}
                        </label>
                      </label>
                    )}
                    <label className="c-form__group c-form__col">
                      <span className="c-form__label">Nivel alcanzado</span>
                      <span className="c-form__select">
                        <select
                          className="c-form__input"
                          name={`languages.${index}.level`}
                          defaultValue="basico"
                          {...register(`languages.${index}.level`)}
                        >
                          <option value="" disabled>
                            Seleccione un nivel
                          </option>
                          <option value="avanzado">Avanzado</option>
                          <option value="intermedio">Intermedio</option>
                          <option value="basico">Básico</option>
                        </select>
                      </span>
                    </label>
                  </div>
                  <div className="c-form__row">
                    <label className="c-form__group">
                      <label className="c-form__group">
                        <span className="c-form__label">Indique dónde realizó los estudios de éste idioma </span>
                        <input
                          type="text"
                          name={`languages.${index}.institution`}
                          className="c-form__input"
                          placeholder="Ingresa el nombre de la institución..."
                          {...register(`languages.${index}.institution`, { required: true })}
                        />
                        {errors?.languages &&
                          errors.languages[index]?.institution &&
                          errors.languages[index]?.institution?.type === "required" && (
                            <span className="c-form__error">Este campo es obligatorio</span>
                          )}
                      </label>
                    </label>
                  </div>
                  <div className="c-form__right-aligner">
                    <button
                      type="button"
                      onClick={() => removeLanguage(index)}
                      className="c-form__btn c-form__btn-delete u-tap-size"
                    >
                      <span className="c-form__btn-icon icon-delete"></span>Eliminar idioma
                    </button>
                  </div>
                </li>
              );
            })}
        </ul>
        {/* <!-- SEPARATOR --> */}
        <div className="c-profile-info__separator"></div>

        {/* <!-- AÑADIR OTRO IDIOMA --> */}
        <button type="button" onClick={addLanguage} className="c-form__btn-add--xl">
          <span className="c-form__btn-add-icon c-form__btn-add-icon--xl icon-more"></span>Añadir otro idioma
        </button>
      </div>
    </div>
  );
}
